<template>
	<div class="con">
		<div class="head" v-if="type == 1">
			<div class="head-left">
				<img src="../assets/doctor.png" v-if="docUser.HEAD_PORTRAIT_URL == '' || docUser.HEAD_PORTRAIT_URL == undefined" />
				<img :src="docUser.HEAD_PORTRAIT_URL" alt="" v-else />
				<div class="userDetalis">
					<div class="username">{{docUser.YGXM}}</div>
					<div class="user-disp">
						<div class="usertype">{{docUser.JBMC}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="head" v-if="type == 0">
			<div class="head-left">
				<img class="logo" src="@/assets/logo.png">
				<div>
					<div>天峨妇幼保健医院</div>
				</div>
			</div>
		</div>
		<!-- <div class="introduce-text">
			{{textHospital}}
		</div> -->
		<div class="box-list">
			<div class="xing-list" v-if="type == 1">
				<div v-for="(item,index) in 5" :key="index" class="xing" @click="xingBtn(index)">
					<van-icon name="star-o" v-if="index + 1 > xingNum" size="30" />
					<van-icon name="star" v-else class="xingColor" size="30" />
				</div>
			</div>

			<div class="texts">
				<textarea maxlength='100' @input="descInput" v-model="desc" placeholder="请您提出宝贵的意见或者建议:"></textarea>
				<span>{{txtVal}}/100</span>
			</div>
		</div>
		<div class="sub-btn" :class="[timer != null ? 'sub-btn-ccc' : '']" @click="subBtn">提交</div>
	</div>
</template>

<script>
	export default {
		name: 'collectionScore',
		data() {
			return {
				msg: '评论',
				docUser: {},
				cardUserInfo: JSON.parse(localStorage.getItem('cardUserInfo')),
				txtVal: 0,
				desc: '', //评论内容
				xingNum: 0, //评论等级
				type: 0, //0-建议反馈 1-医生评论
				timer: null,
				textHospital: this.$store.state.hospital
			}
		},
		methods: {
			//提交
			subBtn() {
				let that = this;
				let URL;
				let sqlVefify = /select|update|delete|exec|count|’|"|=|;|>|<|%/i;
				let val = this.desc;
				if(sqlVefify.test(val)){
					this.$toast('请不要输入特殊字符')
					return false;
				}
				switch (Number(this.type)) {
					case 0://0-建议反馈
						URL = '/collect/addProposal?wechatId=' + this.cardUserInfo.wechatId + '&name=' + this.cardUserInfo.name + '&tepy=' +
							2 + '&remarks=' + val + '&wechaName=' + this.cardUserInfo.wechaName;
						break;
					case 1:
						if (that.xingNum == 0) {
							this.$toast('请进行星评分')
							return false;
						}

						URL = '/collect/addProposal?wechatId=' + this.cardUserInfo.wechatId + '&name=' + this.cardUserInfo.name +
							'&ysdm=' + this.docUser.YGDM + '&eValue=' + this.xingNum + '&wechaName=' + this.cardUserInfo.wechaName +
							'&tepy=' + 1 + '&remarks=' + val + '&ysmc=' + this.docUser.YGXM;
						break;
				}
				that.$store.commit('Load', true)
				clearTimeout(that.timer)
				that.timer = setTimeout(() => {
					that.$Axios.Post(URL, null).then(res => {
						console.log(res)
						that.$store.commit('Load', false)
						if (res.data.code == 0) {
							that.$toast.success('评论成功')
							setTimeout(() => {
								that.$router.go(-1);
							}, 500)
						} else {
							that.$toast('请检查网络')
						}
					}).catch(err => {
						that.$store.commit('Load', false)
						console.log(err)
					})
					that.timer = null;
				}, 300)
				
			},


			xingBtn(e) {
				console.log(e)
				this.xingNum = e + 1;
			},
			descInput() {
				this.txtVal = this.desc.length;
			},

		},
		mounted() {
			
			if (this.$route.query.type == undefined) {
				this.docUser = JSON.parse(this.$route.query.doctor);
				console.log(this.docUser)
				this.type = 1;
			} else {
				this.type = this.$route.query.type
			}
			console.log(this.type)
		},
		created() {},
	}
</script>

<style scoped>
	.head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px;
		background-color: #fff;
	}

	.head-left {
		display: flex;
		align-items: center;
	}

	.head-left img {
		margin-right: 10px;
		width: 60px;
		height: 60px;
	}

	.username {
		color: #000000;
		font-size: 15px;
	}

	.usertype {
		margin: 0 5px;
		color: #666;
	}

	.user-disp {
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		font-size: 13px;
	}

	.head-right {
		display: flex;
		text-align: center;
	}


	.code-text {
		margin-top: 5px;
		font-size: 14px;
	}

	.code-text-active {
		margin-top: 5px;
		font-size: 14px;
		color: #F4EA2A;
	}

	.logo {
		width: 100px;
		height: 100px;
	}

	.introduce-text {
		padding: 10px ;
		text-indent: 2em;
		font-size: 14px;
		color: #666;
	}

	.list {
		padding: 10px;
		margin-top: 10px;
		background-color: #fff;
	}

	.xing-list {
		display: flex;
	}

	.xing {
		margin: 5px;
	}

	.xingColor {
		color: #F4EA2A;
	}

	.texts {
		position: relative;
		text-align: center;
	}

	.texts textarea {
		margin: 10px 0;
		width: 90%;
		height: 150px;
		border-radius: 8px;
	}

	.texts span {
		position: absolute;
		bottom: 15px;
		right: 20px;
		font-size: 14px;
		color: #FF0000;
	}

	.sub-btn {
		padding: 6px 0;
		margin: 10px auto;
		width: 90%;
		background-color: #27BEC4;
		color: #fff;
		text-align: center;
		font-size: 18px;
		border-radius: 8px;
	}
	.sub-btn-ccc{
		background-color: #ccc;
	}
</style>
